import Event from "common/event";
import { Dispatch } from "redux";
import userPreferenceService from "./userPreference.service";
import UserPreference from "./userPreference";

export class PreferencesLoaded extends Event {
    constructor(public prefences: UserPreference[]) {
        super(PreferencesLoaded.EventName);
    }

    public static EventName: string = "userPreference/load";
}

export class PreferenceUpdated extends Event {
    constructor(public key: string, public value: string) {
        super(PreferenceUpdated.EventName);
    }

    public static EventName: string = "userPreference/updated";
}

export function load(dispatch: Dispatch<any>): any {
    return userPreferenceService.listAllPreferences().then(result => {
       dispatch(new PreferencesLoaded(result).toObject());
    })
}

export function update(key: string, value: string, dispatch: Dispatch<any>): any {
    dispatch(new PreferenceUpdated(key, value).toObject());
    userPreferenceService.updateUserPreference(key, value);
} 
